/* eslint-disable*/
import { connect } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import moment from 'moment';
import { Button } from '@mui/material';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import BackdropLoader from '../../Components/Loaders/BackdropLoader';
import { ListTable } from '../../Components/ListTable';
import allVendorServices from '../../Services/Form Services/allvendor.services';
import { formActions, modalActions } from '../../Actions';
import DynamicTableModal from '../../Components/Modals/DynamicTableModal/DynamicTableModal';
import { notificationServices } from '../../Services';
import { urls } from '../../Constants';
import { classes, filtersInfoChip, getActionColumn, getBase64FromFileBlob, handleResponseStreamDownload } from '../../Helpers';
import styles from './listVendorContract.module.scss';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import drawerActions from '@/Actions/drawer.actions';
import ExportFiltersDrawer from '@/Components/Drawers/ExportFiltersDrawer/ExportFiltersDrawer';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Filter } from 'lucide-react';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Buyer',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Term',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expiry Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
];

const ADDITIONAL_COLUMNS = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];

const COL_MAP = {
	ID: 'id',
	Vendor: 'vendorName',
	Buyer: 'vendorName',
	'Payment Term': 'paymentTerm',
	'Expiry Date': 'expiryDate',
	Status: 'status',
	Edit: 'id',
	Cancel: 'id',
};

const ListVendorContractPage = (props) => {
	const {
		toggleModal,
		toggleAlert,
		type,
		toggleExportFiltersDrawer,
		stores,
		fetchStoreList,
		toggleFiltersDrawer,
	} = props;
	const [contractData, setContractData] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const { userConfig } = useAuth();
	const {level} = userConfig?.userDetails || {};
	const [filters, setFilters] = useState({});
	const contractUploadInputRef = useRef(null);
	const history = useHistory();
	const location = useLocation();
	
	useEffect(() => {
		fetchStoreList({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
					type: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const fetchContracts = async () => {
		try {
			setLoading(true);
			const req = {
				pageType: type,
			};
			const response = await allVendorServices.ListVendorContract(req);
			if (response?.statusCode === 200) {
				const contracts = response?.data?.map((contract) => {
					const expiryDate = moment(contract?.expiryDate);
					let status = 'Valid';

					if (contract?.isDeleted) {
						status = 'Cancelled';
					} else if (expiryDate.isSame(moment(), 'day')) {
						status = 'Expiring today';
					} else if (expiryDate.isBefore(moment())) {
						status = 'Expired';
					} else if (expiryDate.isBefore(moment().add(1, 'day'))) {
						status = 'Expiring tomorrow';
					} else if (expiryDate.isBefore(moment().add(1, 'month'))) {
						status = 'Expiring within 1 month';
					}
					return {
						...contract,
						status,
					};
				});
				setContractData(contracts);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
	};
	// useEffect(() => {
	// 	if (!fetchonMount && !history?.location?.state?.prevPath) {
	// 		fetchContracts();
	// 	}
	// }, []);

	// useEffect(() => {
	// 	if (!fetchonMount && !history?.location?.state?.prevPath) {
	// 		fetchContracts();
	// 	}
	// }, [type]);

	const handleFind = async (data) => {
		setFilters(data);
		try {
			setLoading(true);
			const filter = {
				// ...data,
				store : data?.store?.id,
				...(type === 'BUYER' ? {
					vendors : data?.buyer?.id,
				} : {
					vendors : data?.vendors?.id,
				}),
				
				productCategories : data?.productCategories?.id,
				products : data?.products?.id,
				dateRangeFilter: {
					timeType: data?.timeType?.value,
					from: moment(data?.dateRange?.from).format(
						'YYYY-MM-DD'
					),
					to: moment(data?.dateRange?.to).format('YYYY-MM-DD'),
				},
				pageType: type,
			};
			const response = await allVendorServices.VendorContractFilter(filter);
			if (response?.statusCode === 200) {
				const contracts = response?.data?.map((contract) => {
					const expiryDate = moment(contract?.expiryDate);
					let status = 'Valid';

					if (contract?.isDeleted) {
						status = 'Cancelled';
					} else if (expiryDate.isSame(moment(), 'day')) {
						status = 'Expiring today';
					} else if (expiryDate.isBefore(moment())) {
						status = 'Expired';
					} else if (expiryDate.isBefore(moment().add(1, 'day'))) {
						status = 'Expiring tomorrow';
					} else if (expiryDate.isBefore(moment().add(1, 'month'))) {
						status = 'Expiring within 1 month';
					}
					return {
						...contract,
						status,
					};
				});
				setContractData(contracts);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
		return data;
	};

	const handleAddClick = () => {
		if (type === 'BUYER') {
			history.push(`/console2/buyer/contract/create?type=${type}`, {prevPath: location?.pathname + location?.search});
		} else {
			history.push(`/console2/vendor/contract/create?type=${type}`, {prevPath: location?.pathname + location?.search});
		}
	};

	const handleContractUpload = async (event) => {
		const file = event?.target?.files?.[0];
		if (!file) {
			return;
		}
		try {
			setLoading(true);
			const base64File = await new Promise((resolve) => {
				getBase64FromFileBlob(file, resolve);
			});
			const response = await allVendorServices.uploadVendorContract({
				contractData: base64File,
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message || 'Vendor contracts uploaded successfully',
				});
				await fetchContracts();
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message || 'Unable to upload vendor contracts',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || 'Unable to upload vendor contracts',
			});
		} finally {
			if (event?.target) {
				event.target.value = '';
			}
			setLoading(false);
		}
	};

	const downloadVendorContractTemplate = () => {
		const headers = [
			'UY Entity Id',
			'Entity Code',
			'City Name',
			'State Name',
			'Region Name',
			'Contract End Date',
			'Payment Terms',
			'UY Variant ID',
			'SKU Code',
			'Rate',
		];
		const sampleRow = [
			'',
			'VENDOR_001',
			'',
			'',
			'North',
			'12/31/2026',
			'Net 30',
			'',
			'SKU_001',
			'125.50',
		];
		const csvContent = [headers, sampleRow].map((row) => row.join(',')).join('\n');
		const fileBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const downloadLink = document.createElement('a');
		downloadLink.href = window.URL.createObjectURL(fileBlob);
		downloadLink.download = 'vendor_contract_upload_template.csv';
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
	};

	const fetchContractInfo = async (contractId) => {
		try {
			setLoading(true);
			const response = await allVendorServices.VendorContractInfo({
				contractId,
			});
			if (response?.statusCode === 200) {
				toggleModal(true, response?.data);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
		return {};
	};

	const handleViewClick = (contract) => {
		fetchContractInfo(contract?.id);
	};

	const handleDelete = async (contractId) => {
		try {
			setLoading(true);
			const response = await allVendorServices.VendorContractDelete({
				contractId,
				type,
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'contract cancelled successfully',
				});
				const remainingContract = contractData.map((contract) => {
					if (contract.id === contractId) {
						// eslint-disable-next-line no-param-reassign
						contract.status = 'Cancelled';
					}
					return contract;
				});

				setContractData(remainingContract);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
	};

	const SPECIAL_ITEMS = {
		'Expiry Date': (date) => {
			return moment(date).format('YYYY-MM-DD');
		},
		Actions: (contractId) => {
			const contractAction = contractData.find((contractTmp) => {
				return contractTmp.id === contractId;
			});
			return (
				<div>
					{contractAction?.status !== 'Cancelled' && (
						<>
							<Button
								onClick={() => {
									if (type === 'BUYER') {
										history.push(
												`${urls.EXTENSION}${urls.BUYER_CONTRACT_CREATE}?isEdit=True&contractId=${contractId}&type=${type}`,
												{
													prevPath: location?.pathname + location?.search,
												}
										);
									} else {
										history.push(
											`${urls.EXTENSION}${urls.VENDOR_CONTRACT_CREATE}?isEdit=True&contractId=${contractId}&type=${type}`,
											{
												prevPath: location?.pathname + location?.search,
											}
										);
									}
								}}
								variant='outlined'
								color='primary'
								fullWidth
							>
								Edit
							</Button>
							<div
								style={{
									width: '125px',
								}}
							>
								<Button
									variant='outlined'
									color='error'
									onClick={() => {
										const deleteContract = contractData.find((contract) => {
											return contract.id === contractId;
										});
										toggleAlert(true, {
											heading: 'Cancel Contract?',
											handleConfirm: () => {
												handleDelete(contractId);
												toggleAlert(false);
											},
											colorReverse: false,
											cancelText: 'No',
											confirmText: 'Yes',
											message: `Are you sure you want to Cancel contract for ${deleteContract?.vendorName ?? 'vendor'}?`,
										});
									}}
									fullWidth
								>
									Cancel
								</Button>
							</div>
						</>
					)}

				</div>
			);
		},
	};
	const handleExport = async(filters) => {
		if(!filters?.store?.id) return notificationServices?.generateNotification({
			type: 'error',
			message: 'Please select a Store for Export',
		});
		setLoading(true);
		try{
			const req = {
				data: {
					storeId : filters?.store?.id,
				}
			};
			if(type === 'BUYER'){
				const response = await allVendorServices?.exportBuyerContract(req);
				if(response.status === 200){
					handleResponseStreamDownload(response, 'Buyer Contract.csv');
				}
			}else {
				const response = await allVendorServices?.exportVendorContract(req); 
				if(response.status === 200){
					handleResponseStreamDownload(response, 'Vendor Contract.csv');
				}
			}
		}catch(error){
			notificationServices?.generateNotification({
				type: 'error',
				message: error,
			});
		}finally{
			setLoading(false);
		}
	}
	// export function 
	// const openExportDrawer = () => {
	// 	toggleExportFiltersDrawer(true, {
	// 		heading: type === 'BUYER' ? 'Export Buyer Contract' : 'Export Vendor Contract',
	// 		// note: 'Filters are disabled for now, they will be LIVE Soon!',
	// 		onConfirm: (args) => {
	// 			const { filtersState } = args ?? {};
	// 			handleExport(filtersState);
	// 		},
	// 		filterData: [
	// 			{
	// 				type: 'singleSelect',
	// 				dependentOn: -1,
	// 				compData: stores
	// 					// ?.filter((ele) => {
	// 					// 	return ele?.type === 'BASE';
	// 					// })
	// 					?.map((ele) => {
	// 						return {
	// 							id: ele?.id,
	// 							label: ele?.name,
	// 							title: ele?.name,
	// 							value: ele?.id,
	// 						};
	// 					}),
	// 				selectBy: 'id',
	// 				label: ' Select Stores',
	// 				selectedValueKey: 'storeId',
	// 				dateFormat: null,
	// 				disabled: false,
	// 				defaultState: null,
	// 				mandatory: true,
	// 			},
	// 		],
	// 	});
	// };

	const filtersInfo = {
		header : {
			store : false,
			product : false,
			date: false,
		},
		store : {
			text: 'Region',
			show: true,
		},
		product : {
			text: 'Product',
			show: true,
		},
		dateRangeOnly : {
			text: 'Expiry Date',
			show: true,
		},
		...(type === 'BUYER' ? {
			buyer : {
				text: 'Buyer',
				show: true,
			},
		} : {
			vendor : {
				text: 'Vendor',
				show: true,
			},
		}),
		productCategory : {
			text: 'Product Category',
			show: true,
		},
	};
	const exportInfo = {
		showExportBtn : true,
	};

	return (
		<div>
			<DynamicTableModal isBuyer={type === 'BUYER'} />
			<BackdropLoader isLoading={isLoading} showProgress />
			<ExportFiltersDrawer />
				<div className='flex justify-between m-4 p-2 '>
				<span className='font-bold text-[16px]'>{type === 'BUYER' ? 'Buyer Contract' : 'vendor Contract'}</span>
				<div className='flex gap-2'>
				{type !== 'BUYER' && level !== 1 && (
					<>
						<input
							ref={contractUploadInputRef}
							type='file'
							accept='.csv,text/csv'
							style={{ display: 'none' }}
							onChange={handleContractUpload}
						/>
						<Button
							onClick={() => {
								contractUploadInputRef.current?.click();
							}}
							className='bg-blue-600 hover:bg-blue-700 rounded-md flex items-center justify-center gap-2 text-white'
						>
							Upload Vendor Contract
						</Button>
						<Button
							onClick={downloadVendorContractTemplate}
							className='bg-slate-600 hover:bg-slate-700 rounded-md flex items-center justify-center gap-2 text-white'
						>
							Download Template
						</Button>
					</>
				)}
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							handleDataExport : (req) => handleExport(req),
						});
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap capitalize'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
				{level !== 1 && (
					<Button
						onClick={handleAddClick}
						className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
					>
						+ {type === 'BUYER' ? 'Add Buyer Contract' : 'Add Vendor Contract'}
					</Button>
				)}
				</div>
			</div>
				<ImagesFinder
					onSubmit={handleFind}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
				{filtersInfoChip(filtersInfo, filters)}

				<ListTable
					columns={TABLE_COLUMNS?.filter((ele) => {
						if (type === 'BUYER') {
							return ele?.title !== 'Vendor';
						}
						if(type === 'VENDOR'){
							return ele?.title !== 'Buyer';
						}
						return true;
					})}
					colMap={type === 'BUYER'
						? Object.fromEntries(Object.entries(COL_MAP).filter(([key]) => key !== 'Vendor'))
						: Object.fromEntries(Object.entries(COL_MAP).filter(([key]) => key !== 'Buyer'))}
					actions={getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level)}
					handleViewClick={handleViewClick}
					special={SPECIAL_ITEMS}
					data={contractData?.map((ele) => {
						const status = ele?.status?.split(' ').join('_');
						return {
							...ele,
							rowStyles: classes(
								styles.row,
								styles?.[status]
							),
						};
					})}
					allowExport={false}
					showBtnContainer={false}
				/>

		</div>
	);
};

const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { userList } = state.auth;
	const stores = state?.form?.FILTERED_STORES?.data?.LIST;
	return {
		userPermissions,
		navState,
		userList,
		stores,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleDynamicTableModal,
	toggleAlert: modalActions.toggleAlert,
	fetchUserList: authActions.fetchUserList,
	fetchStoreList: formActions.gateway,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};
export default connect(mapStateToProps, mapDispatchToProps)(ListVendorContractPage);
